import React from "react";
import styled from "styled-components/macro"; // eslint-disable-line no-unused-vars
import Link from "./Link";
import Box from "./Box";

const variants = {
  default: {
    border: "soft",
    color: "inherit"
  },
  primary: {
    bg: "primary",
    color: "onPrimary",
    border: "soft",
    css: { textDecoration: "none" }
  }
};

const sizes = {
  sm: {
    p: 2,
    fontSize: 1,
    lineHeight: 1
  },
  md: {
    p: 3
  }
};

export default function Button({ variant, size, to, href, css, ...rest }) {
  const variantProps = variants[variant] || variants.default;
  return (
    <Box
      as={to ? Link : href ? "a" : undefined}
      variant={to ? "basic" : undefined}
      to={to}
      href={href}
      display="inline-block"
      {...variantProps}
      {...sizes[size] || sizes.md}
      css={[variantProps.css, css]}
      {...rest}
    />
  );
}
